var render = function render(){var _vm=this,_c=_vm._self._c;return _c('project-list-item-actions',{attrs:{"id":"project-more-action-dropdown","project":_vm.project},on:{"action":_vm.handleAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }